import type { ReactNode } from 'react';

import { cn } from '@crm/shared/lib';

import { BOARD_COLUMN_WIDTH_CLASS_NAME } from '../../config';

type ColumnPreviewFrameProps = {
    children: ReactNode;
    color: string;
    bgColor: string;
};

export const ColumnPreviewFrame = ({ children, color, bgColor }: ColumnPreviewFrameProps) => (
    <div
        className={cn(
            BOARD_COLUMN_WIDTH_CLASS_NAME,
            'relative flex min-h-0 flex-col items-start gap-4.5 self-start overflow-x-hidden rounded-[10px] px-2 py-2.5'
        )}
        style={{
            backgroundColor: bgColor,
            borderTop: `3px solid ${color}`,
        }}
    >
        {children}
    </div>
);
